import { ThumbsUp, ThumbsDown, AlertCircle } from "lucide-react";

export const GmailPromotionsFactors = () => {
  const promotionsSignals = [
    "Heavy HTML with tables, images, buttons",
    "Unsubscribe link present (ironic but true)",
    "Marketing language: 'Buy now', 'Limited time', 'Sale'",
    "Sent from known ESP domains (Mailchimp, Sendgrid, etc.)",
    "Tracking pixels and click tracking",
    "Multiple calls-to-action",
    "Color-heavy designs with brand logos",
    "Bulk sending patterns"
  ];

  const primarySignals = [
    "Plain text or minimal HTML",
    "Personal, conversational tone",
    "Single recipient (not bulk)",
    "Reply history with recipient",
    "Sent from personal domain",
    "No tracking pixels",
    "Simple signatures",
    "Recipient frequently engages"
  ];

  return (
    <section className="py-8 sm:py-10">
      <div className="mb-6 sm:mb-8">
        <h2 className="font-display text-2xl sm:text-3xl font-bold text-foreground mb-2">
          What Triggers Each Tab
        </h2>
        <p className="text-muted-foreground">
          Signals Gmail's algorithm uses to classify your emails
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {/* Promotions Signals */}
        <div className="bg-card border border-warning/20 rounded-xl overflow-hidden">
          <div className="bg-warning/10 p-4 border-b border-warning/20">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-warning/20 flex items-center justify-center">
                <ThumbsDown className="w-5 h-5 text-warning" />
              </div>
              <div>
                <h3 className="font-display font-semibold text-foreground">
                  Promotions Tab Signals
                </h3>
                <p className="text-sm text-muted-foreground">These patterns trigger Promotions placement</p>
              </div>
            </div>
          </div>
          <div className="p-4">
            <ul className="space-y-2">
              {promotionsSignals.map((signal, index) => (
                <li key={index} className="flex items-start gap-2 text-sm">
                  <AlertCircle className="w-4 h-4 text-warning shrink-0 mt-0.5" />
                  <span className="text-muted-foreground">{signal}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Primary Signals */}
        <div className="bg-card border border-success/20 rounded-xl overflow-hidden">
          <div className="bg-success/10 p-4 border-b border-success/20">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-success/20 flex items-center justify-center">
                <ThumbsUp className="w-5 h-5 text-success" />
              </div>
              <div>
                <h3 className="font-display font-semibold text-foreground">
                  Primary Tab Signals
                </h3>
                <p className="text-sm text-muted-foreground">These patterns favor Primary placement</p>
              </div>
            </div>
          </div>
          <div className="p-4">
            <ul className="space-y-2">
              {primarySignals.map((signal, index) => (
                <li key={index} className="flex items-start gap-2 text-sm">
                  <ThumbsUp className="w-4 h-4 text-success shrink-0 mt-0.5" />
                  <span className="text-muted-foreground">{signal}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Important Note */}
      <div className="mt-6 p-4 bg-info/5 border border-info/20 rounded-xl">
        <div className="flex items-start gap-3">
          <AlertCircle className="w-5 h-5 text-info shrink-0 mt-0.5" />
          <div className="text-sm text-muted-foreground">
            <span className="font-medium text-foreground">Important:</span> Gmail's classification is per-user. 
            The same email can land in Primary for one user and Promotions for another, based on their individual 
            engagement history. Source: Google Support Documentation 2024.
          </div>
        </div>
      </div>
    </section>
  );
};
